import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";

const VerifyUser = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const navigate = useNavigate();

  const [status, setStatus] = useState("verifying"); // verifying, success, error
  const [message, setMessage] = useState("Verifying your email...");

  useEffect(() => {
    const verifyEmail = async () => {
      if (!token) {
        setStatus("error");
        setMessage(
          "No verification token found. Please check your email link."
        );
        return;
      }

      try {
        const response = await axios.get(`/api/auth/verify/${token}`);
        setStatus("success");
        setMessage(
          response.data.message ||
            "Email verified successfully. You can now log in."
        );
      } catch (error) {
        setStatus("error");
        setMessage(
          error.response?.data?.message ||
            "Failed to verify email. The link may be expired or invalid."
        );
      }
    };

    verifyEmail();
  }, [token]);

  return (
    <div className="verification-container">
      <div className={`verification-card verification-${status}`}>
        <div className="verification-icon">
          {status === "verifying" && (
            <div className="verification-spinner"></div>
          )}
          {status === "success" && <div className="verification-check">✓</div>}
          {status === "error" && <div className="verification-error">!</div>}
        </div>

        <h1 className="verification-title">
          {status === "verifying" && "Verifying Email"}
          {status === "success" && "Email Verified!"}
          {status === "error" && "Verification Failed"}
        </h1>

        <p className="verification-message">{message}</p>

        {status === "success" && (
          <div className="verification-actions">
            <button
              onClick={() => navigate("/login")}
              className="verification-button"
            >
              Go to Login
            </button>
            <button
              onClick={() => navigate("/")}
              className="verification-button verification-secondary"
            >
              Go to Home Page
            </button>
          </div>
        )}

        {status === "error" && (
          <div className="verification-actions">
            <button
              onClick={() => navigate("/login")}
              className="verification-button"
            >
              Go to Login
            </button>
            <button
              onClick={() => navigate("/resend-verification")}
              className="verification-button verification-secondary"
            >
              Resend Verification
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default VerifyUser;
